<template>
  <v-dialog v-model="dialogModel" max-width="400">
    <v-card>
      <v-card-title class="font-weight-bold headline red white--text"
        ><v-icon color="white" left>mdi-alert</v-icon> AVISO
        <v-spacer></v-spacer>
        <v-icon color="white" @click="setDialogAviso(false)">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-alert>
          <div
            class="title mt-5 modal-aviso"
            v-html="pendencias.msg_aviso_senha_compra_prazo"
          ></div>
        </v-alert>
        <v-row>
          <v-col cols="12">
            <p class="font-weight-bold title black--text">
              Cadastrar senha agora?
            </p>
          </v-col>
          <v-col cols="6" class="d-flex justify-center">
            <v-btn
              rounded
              color="success"
              :to="{ path: '/config-compras-prazo' }"
              >Sim</v-btn
            >
          </v-col>
          <v-col cols="6" class="d-flex justify-center">
            <v-btn rounded color="error" @click="setDialogAviso(false)"
              >Não</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  computed: {
    ...mapState("usuario", ["pendencias"]),
    ...mapState("configComprasPrazo", ["dialogAviso"]),
    dialogModel: {
      get: function () {
        return this.dialogAviso;
      },
      set: function (value) {
        this.setDialogAviso(value);
      },
    },
  },
  methods: {
    ...mapMutations("configComprasPrazo", ["setDialogAviso"]),
  },
};
</script>

<style>
.modal-aviso p {
  margin-bottom: 16px !important;
}
</style>